import React from 'react';

// eslint-disable-next-line react/prop-types
const EmployerBenefit = ({ title, text, isLeft }) => {
  return (
    <>
      {isLeft ? (
        <div className="benefits mt-3 text-left">
          <h4>{title}</h4>
        </div>
      ) : (
        <div className="benefits mt-3 text-right">
          <h4>{title}</h4>
        </div>
      )}
      <hr />
    </>
  );
};

export default EmployerBenefit;
